<div class="content-area">
  <app-loading-component *ngIf="isLoading"></app-loading-component>
  <div class="clr-row" *ngIf="!isLoading">
    <div class="clr-col-10 clr-col-md-8">
      <h1>Recenzii jocuri biblice și produse creștine pentru copii</h1>
    </div>
    <div class="clr-col-10 clr-col-md-8" id="posts-wrapper">
      <app-review-thumbnail *ngFor="let post of posts" [postData]="post"></app-review-thumbnail>
      <div *ngIf="!posts || (posts && posts.length < 1)" class="text-center">
        Ne pare rău, se pare că nu avem încă conținut în această secțiune.
      </div>
    </div>
  </div>
</div>
